import OperatingHours from './OperatingHours';

export default OperatingHours;
